<mat-toolbar class="main-header">
  @if (sidenav.mode === "over" && isMe) {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  @if (!isMe && user) {
    <button
      mat-icon-button
      (click)="goBack()"
      aria-label="Volver al resumen del usuario"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="header-avatar-wrap">
      <app-avatar [user]="user"></app-avatar>
    </div>
  }
  <span>{{ user?.name }}</span>
  <span class="spacer"></span>
  <div class="header-actions">
    @if (canSavePredictions) {
      <button
        mat-icon-button
        class="clear-results-btn"
        [disabled]="isAiAutofillLoading || !pollProcessed"
        [matTooltip]="clearResultsTooltip"
        [attr.aria-label]="clearResultsTooltip"
        (click)="clearAllResults()"
      >
        <mat-icon>delete_sweep</mat-icon>
      </button>

      <button
        mat-icon-button
        class="ai-fill-btn"
        [disabled]="isAiAutofillLoading || !pollProcessed"
        [matTooltip]="aiAutofillTooltip"
        [attr.aria-label]="aiAutofillTooltip"
        (click)="autofillMissingResultsWithAi()"
      >
        <mat-icon>
          @if (isAiAutofillLoading) {
            hourglass_top
          } @else {
            auto_awesome
          }
        </mat-icon>
      </button>
    }
  </div>
</mat-toolbar>

@if (user) {
  <div class="poll-champion-bar" (click)="showChampionForm()">
    <div class="champ-left">
      @if ((isAdmin || currentTimestamp >= firstRoundIniTimestamp) && championTeam) {
        <img
          class="champ-flag"
          [src]="championTeam.flag"
          [alt]="championTeam.name"
        />
      } @else {
        <div class="champ-icon-wrap"><mat-icon>emoji_events</mat-icon></div>
      }
      <div class="champ-details">
        <span class="champ-title">Campeón &amp; Pichichi</span>
        <span class="champ-sub">
          @if (isAdmin || currentTimestamp >= firstRoundIniTimestamp) {
            @if (championTeam) {
              {{ championTeam.name }}
            } @else {
              Sin seleccionar
            }
            @if (pichichiName) {
              · ⚽ {{ pichichiName }}
            }
          } @else {
            {{
              isMe ? "Toca para configurar" : "Se revela al inicio del torneo"
            }}
          }
        </span>
      </div>
    </div>
    <mat-icon class="champ-arrow">chevron_right</mat-icon>
  </div>

  <div
    class="round-deadline-bar"
    [class.round-deadline-bar--closed]="isRoundClosed"
  >
    <div class="deadline-dot"></div>
    <div class="deadline-copy">
      <span class="deadline-title">Cierre de {{ selectedRoundTitle }}</span>
      <span class="deadline-value">
        @if (isRoundClosed) {
          Pronosticos cerrados para esta ronda
        } @else {
          Faltan {{ roundCountdownLabel }}
        }
      </span>
    </div>
  </div>
}

<div class="poll-content">
  @if (user) {
    @if (!isMe && !isAdmin && currentTimestamp < firstRoundIniTimestamp) {
      <div class="poll-locked-state">
        <span class="poll-locked-emoji">🔒</span>
        <h3 class="poll-locked-title">Pronósticos bajo llave</h3>
        <p class="poll-locked-sub">
          Los pronósticos de <strong>{{ user.name }}</strong> se revelarán
          cuando arranque la fase de grupos.<br />¡Que no haya trampas!
        </p>
      </div>
    } @else {
      <app-matches-list
        [hidden]="!pollProcessed"
        [mode]="matchesViewMode"
        [user]="user"
        (roundChanged)="onRoundChanged($event)"
      ></app-matches-list>
    }
  }
</div>

@if (canSavePredictions) {
  <div class="poll-save-bar">
    <button class="save-btn" (click)="update()">
      <mat-icon>save</mat-icon>
      Guardar pronósticos
    </button>
  </div>
}

<block-ui></block-ui>
